<h1 i18n mat-dialog-title *ngIf="!title">Примечание</h1>
<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<div mat-dialog-content class="flex flex-col items-stretch p-4 pb-0 m-0" fusePerfectScrollbar>
  <ng-container>
    <form name="orderForm" [formGroup]="orderForm" class="flex flex-1 flex-col w-full">
      <mat-form-field class="w-full">
        <textarea
          matInput
          name="note"
          formControlName="note"
          [cdkTextareaAutosize]
          [cdkAutosizeMinRows]="3"
          [cdkAutosizeMaxRows]="10">
        </textarea>
      </mat-form-field>
    </form>
  </ng-container>
</div>

<div mat-dialog-actions class="flex flex-row justify-end items-center m-0 p-4">
  <button
    i18n
    mat-raised-button
    class="mat-accent mr-4"
    [disabled]="orderForm.invalid"
    (click)="dialogRef.close(orderForm.controls.note.value)"
    >ОК</button
  >
  <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
</div>
